import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Dropdown as BootstrapDropdown } from 'react-bootstrap';

import Control from './control';
import MenuItem from './menu_item';
import MenuItems from './menu_items';
import ParentItem from './parent_item';
import { DROPDOWN_CLOSED } from './events';

import './styles.scss';

export function Dropdown({ absolute, children, controlIcon, controlLabel, controlSize, onToggle, ...props }) {
  const [menuParent, setMenuParent] = useState();
  const [menu, setMenu] = useState();

  // TODO: This is to address an issue where the parent component unmounts, but the dropdown
  //       remains (BSD-18851).  This only applies in the case where 'absolute' is true.
  //       Look to find a cleaner solution in the future, possibly using a portal.
  useEffect(() => {
    return function cleanup() {
      if (menu) {
        menu.style.display = 'none';
      }
    };
  });

  const handleToggle = (isOpen, ...args) => {
    if (absolute) {
      handleAbsolutePositioning(isOpen, ...args);
    }

    if (!isOpen) {
      // Tell child MenuItems components (well, all of them) to reset active items
      window.dispatchEvent(new Event(DROPDOWN_CLOSED));
    }

    if (onToggle) {
      onToggle(isOpen, ...args);
    }
  };

  const handleAbsolutePositioning = (isOpen, event) => {
    if (isOpen) {
      const { parent, dropdownMenu } = positionDropdown(event);

      setMenuParent(parent);
      setMenu(dropdownMenu);
    } else {
      menu.style.display = 'none';
      menuParent.appendChild(menu);

      setMenuParent(null);
      setMenu(null);
    }
  };

  function cancelDrag(event) {
    event.preventDefault();
    event.stopPropagation();
  }


  let control;
  if (controlIcon || controlLabel) {
    control = <Control bsRole="toggle" icon={controlIcon} label={controlLabel} size={controlSize} />;
  }

  return (
    <BootstrapDropdown {...props} onDragStart={cancelDrag} onToggle={handleToggle}>
      {control}
      {children}
    </BootstrapDropdown>
  );
}

Dropdown.propTypes = {
  absolute: PropTypes.bool,
  children: PropTypes.node,
  controlIcon: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  controlLabel: PropTypes.string,
  controlSize: PropTypes.string,
  onToggle: PropTypes.func,
};

Dropdown.Control = Control;
Dropdown.Menu = BootstrapDropdown.Menu;
Dropdown.MenuItem = MenuItem;
Dropdown.MenuItems = MenuItems;
Dropdown.ParentItem = ParentItem;
Dropdown.Toggle = BootstrapDropdown.Toggle;

export default Dropdown;

// This is a hack to fix the issue where the menu would not trigger click events.
// In react 17, event listeners are attached to the react root instead of the document body. In this component,
// we disconnect the menu and attach it to the body, and since the click events wouldn't hit the react root, the menu
// became unresponsive.
// To fix this, we can use this to find the react root and attach the menus to that element.
//
// NOTE: Once we upgrade to react-bootstrap > 2, we can ditch the this positioning logic and just set the popper config
// to use absolute positioning
const findReactRoot = (element) => {
  while (element) {
    if (element.id && element.id.includes('react-component')) return element;
    element = element.parentNode;
  }
};

// Returns the parent and menu in order to replace them on close
const positionDropdown = (event) => {
  const parent = event.currentTarget.parentNode;
  const dropdownMenu = parent.querySelector('.dropdown-menu');

  const parentBoundingBox = parent.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  dropdownMenu.style.display = 'block';

  const top = parentBoundingBox.bottom + scrollTop;
  let bottom;

  if (parentBoundingBox.bottom + dropdownMenu.offsetHeight > window.innerHeight) {
    bottom = window.innerHeight - (parentBoundingBox.top + scrollTop);
  }

  let left = scrollLeft;
  if (dropdownMenu.classList.contains('dropdown-menu-right')) {
    const widthDifference = dropdownMenu.offsetWidth - parent.offsetWidth;
    left += (parentBoundingBox.left - widthDifference);
  } else {
    left += parentBoundingBox.left;
  }

  (findReactRoot(parent) || document.body).appendChild(dropdownMenu);
  dropdownMenu.style.left = `${left}px`;
  dropdownMenu.style.right = 'auto';

  if (bottom) {
    dropdownMenu.style.top = 'auto';
    dropdownMenu.style.bottom = `${bottom}px`;
  } else {
    dropdownMenu.style.top = `${top}px`;
    dropdownMenu.style.bottom = 'auto';
  }

  return {
    parent,
    dropdownMenu,
  };
};
